import React, { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { serverUrl } from '../../Constant/Static/config';
import AdminHeader from '../Components/AdminHeader';
import user from '../../Constant/Icons/user.svg';
import peopleIcon from '../../Constant/Icons/people.svg';
import userName from '../../Constant/Icons/username.svg';
import passwordIcon from '../../Constant/Icons/password.svg';
import PopModal from '../../Constant/Custom/Models/PopModal';
import { AuthContext } from '../../Auth/AuthContext';

function AdminLogin() {
    const { loginAdmin } = useContext(AuthContext);

    const [formData, setFormData] = useState({
        username: '',
        password: '',
    });
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [modalType, setModalType] = useState({ title: '', text: '', icon: '' });

    const openModal = () => setIsModalOpen(true);
    const closeModal = () => setIsModalOpen(false);
    const navigate = useNavigate();

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevFormData) => ({
            ...prevFormData,
            [name]: value,
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!formData.username || !formData.password) {
            setModalType({
                icon: 'warning',
                title: 'Invalid Input',
                text: 'Username and password cannot be empty.',
            });
            openModal();
            return;
        }

        const dataToSend = {
            username: formData.username.trim(),
            password: formData.password.trim(),
        };

        try {
            const response = await axios.post(`${serverUrl}/api/admin/login`, dataToSend);
            if (response.status === 200) {
                setModalType({
                    icon: 'success',
                    title: 'Login Successful!',
                    text: response.data.message,
                });
                openModal();
                loginAdmin(response.data.token);
                navigate('/admin/dashboard');
            } else {
                console.log(response.data.message)
            }
        } catch (err) {
            // console.log(err);
            const errorMessage = err.response?.data?.message || 'An error occurred. Please try again.';
            setModalType({
                icon: 'error',
                title: 'Login Failed!',
                text: errorMessage,
            });
            openModal();
            // console.log(errorMessage);
        }
    };

    const handleCancel = () => {
        setFormData({
            username: '',
            password: '',
        });
        closeModal();
    };

    return (
        <div style={{ width: '100dvw', height: '100dvh', backgroundColor: '#f9f9f9' }}>
            <AdminHeader>
                <a href='/admin/login'>
                    <img src={user} alt='Login' width={50} height={50} />
                </a>
            </AdminHeader>
            <div className="login-container">
                <div className="login-inner-container">
                    <img src={peopleIcon} alt="user" width={75} height={75} />
                    <form onSubmit={handleSubmit}>
                        <div className="login-form-group">
                            <input
                                type="text"
                                name="username"
                                value={formData.username}
                                placeholder="Enter Phone Number"
                                onChange={handleChange}
                                required
                            />
                            <img className="IconForInput" src={userName} alt="user" width={20} height={20} />
                        </div>
                        <div className="login-form-group">
                            <input
                                type="password"
                                name="password"
                                value={formData.password}
                                placeholder="Enter Password"
                                onChange={handleChange}
                                required
                            />
                            <img className="IconForInput" src={passwordIcon} alt="user" width={20} height={20} />
                        </div>
                        <div className="login-form-group">
                            <button type="submit" className="login-button">LogIn</button>
                        </div>
                    </form>
                    <div style={{ position: 'relative', alignSelf: 'center', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <PopModal
                            isOpen={isModalOpen}
                            type={modalType}
                            confirmButtonText="OK"
                            onConfirm={handleCancel}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AdminLogin;